// format: [{ key: '1', value: '1' }, ...],

export default [ ...Array(64).keys() ].map((index) => ({ key: `${index}`, value: index }));
